import React from "react"
import { Button, Grid, Typography } from "@material-ui/core"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import { useTrack } from "@hackler/react-sdk"
import { GAEvent } from "../../../modules/GoogleAnalytics"
import useLoginPopup from "../../../hooks/useLoginPopup"
import AbTestVideoDialog from "../../../components/Dialog/AbTestVideoDialog"
import playIcon from "../../../assets/images/icon/play.png"
import abTest from "../../../assets/images/service/abtest.png"
import abTestEn from "../../../assets/images/service/abtest_en.png"
import googleAmazon from "../../../assets/images/service/google_amazon.png"
import googleAmazonMobile from "../../../assets/images/service/google_amazon_mo.png"
import googleAmazonEn from "../../../assets/images/service/google_amazon_en.png"
import Section from "../../../components/Section/Section"
import usePlatform from "../../../hooks/usePlatform"
import { FormattedMessage } from "react-intl"
import { Locale } from "../../../locale"

interface StyleProps {
  lang: string
}
const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#E8EFFC",
      paddingTop: 32,
      // marginBottom: 56,
      padding: "0 16px",
      [theme.breakpoints.up("md")]: {
        paddingTop: 70,
        // marginBottom: 90,
        padding: 0,
      },
    },
    container: {
      alignItems: "center",
      [theme.breakpoints.up("md")]: {
        maxWidth: 1200,
        margin: "0 auto",
      },
    },
    header: {
      width: "50%",
      [theme.breakpoints.up("md")]: {
        width: ({ lang }) => (lang === "ko" ? 226 : 356),
      },
    },
    desc: {
      marginBottom: 16,
      [theme.breakpoints.up("md")]: {
        marginBottom: "inherit",
      },
    },
    buttonContainer: {
      justifyContent: "center",
      marginBottom: 16,
      [theme.breakpoints.up("md")]: {
        marginBottom: "inherit",
      },
    },
    button: {
      borderRadius: 8,
      textTransform: "none",
      color: theme.palette.common.white,
      padding: "8px 12px",
      fontSize: 14,
      [theme.breakpoints.up("md")]: {
        fontSize: 20,
        padding: "12px 20px",
      },
    },
    videoButton: {
      padding: "8px 12px",
      textTransform: "none",
      borderWidth: 2,
      borderRadius: 6,
      fontWeight: 700,
      fontSize: 14,
      borderColor: theme.palette.primary.main,
      "&:hover": {
        fontSize: 14,
        borderWidth: 2,
      },
      [theme.breakpoints.up("md")]: {
        borderRadius: 8,
        fontSize: 20,
        padding: "12px 20px",
        "&:hover": {
          fontSize: 20,
        },
      },
    },
    imageWrapper: {
      // position: "relative",
      // marginBottom: -90,
      "& img": {
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        // marginBottom: -90,
      },
    },
    image: {
      [theme.breakpoints.up("md")]: {
        marginLeft: 50,
      },
    },
  })
)

export default function HeroSection() {
  const track = useTrack()
  const { lang } = Locale.getDefault()
  const loginPopup = useLoginPopup()
  const { isMobile } = usePlatform()
  const classes = useStyles({ lang })

  return (
    <Section
      spacing={isMobile ? 2 : 6}
      containerClassName={classes.container}
      containerDirection={"column"}
      className={classes.root}>
      <Grid item>
        {lang === "ko" ? (
          <>
            <Grid item style={{ textAlign: "center" }}>
              <img
                className={classes.header}
                src={isMobile ? googleAmazonMobile : googleAmazon}
                alt={"구글, 아마존의 성공 비결"}
              />
            </Grid>
            <Typography variant={"h2"} className={classes.desc}>
              A/B 테스트를 통해 실패를 줄이고
              <br />
              안정적으로 성장할 수 있습니다
            </Typography>
          </>
        ) : (
          <>
            <Grid item style={{ textAlign: "center" }}>
              <img className={classes.header} src={googleAmazonEn} alt={"google, amazon's success secret"} />
            </Grid>
            <Typography variant={"h2"} className={classes.desc}>
              Reduce failures
              <br />
              and boost growth with A/B testing
            </Typography>
          </>
        )}
      </Grid>
      <Grid item>
        <Grid container spacing={3} className={classes.buttonContainer}>
          <Grid item>
            <AbTestVideoDialog
              ButtonElement={(onClick) => (
                <Button
                  color={"primary"}
                  // variant={"outlined"}
                  startIcon={<img src={playIcon} alt={"play"} />}
                  className={classes.videoButton}
                  onClick={onClick}>
                  <FormattedMessage id={"preview_video"} />
                </Button>
              )}
            />
          </Grid>
          <Grid item>
            <Button
              onClick={() => {
                track({ key: "homepage_ab_test_main_start_ab_test_click" })
                GAEvent({
                  category: "abtest-1",
                  action: "click",
                  label: "start abtest",
                })
                loginPopup()
              }}
              color={"primary"}
              variant={"contained"}
              className={classes.button}>
              <strong>
                <FormattedMessage id={"btn_ab_test_hero_section"} />
              </strong>
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid item md={10} xs={12}>
        <div className={classes.imageWrapper}>
          <div className={classes.image}>
            <img src={lang === "ko" ? abTest : abTestEn} alt={"ab test"} />
          </div>
        </div>
      </Grid>
    </Section>
  )
}
